import { useMemo } from 'react';
import constants from '../../../config/constants';
import { getReaconditionedValues } from '../../../utils/product/productUtils';

/**
 * Custom hook that encapsulates all business logic for ReaconditionedContainer
 * @param {Object} props - Component props
 * @param {Object} props.appCtx - Application context with site configuration
 * @param {Object} props.productAttributes - Product attributes containing specifications
 * @returns {Object} - Processed data and computed values
 */
export const useReaconditionedContainer = ({ appCtx, productAttributes }) => {
  const processedData = useMemo(() => {
    // Get condition from product attributes
    const condition = getReaconditionedValues(productAttributes);

    const isReaconditionedLinkEnabled = appCtx?.siteConfig?.toggles?.isReaconditionedLinkEnabledPDP ?? false;

    const reaconditionedLink =
      appCtx?.store === constants.STORES.so_com
        ? appCtx?.siteConfig?.textDictionary?.SO_COM_REACONDITIONED_LINK ?? ''
        : appCtx?.siteConfig?.textDictionary?.REACONDITIONED_LINK ??
          'https://assets.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt6e6552e1707e37fd/productos-reacondicionados.pdf';

    return {
      condition,
      isReaconditionedLinkEnabled,
      reaconditionedLink,
    };
  }, [appCtx, productAttributes]);

  const computedValues = useMemo(
    () => ({
      shouldRender: Boolean(processedData.condition && processedData.condition.name !== 'nuevo'),
      messageText: processedData.condition
        ? `Este producto ${processedData.condition.name === 'detalle estético' ? 'tiene' : 'es'} `
        : '',
      showLink: Boolean(processedData.isReaconditionedLinkEnabled && processedData.reaconditionedLink),
    }),
    [processedData.condition, processedData.isReaconditionedLinkEnabled, processedData.reaconditionedLink]
  );

  return {
    // Processed data
    ...processedData,

    // Computed values with spread
    ...computedValues,
  };
};
